// Lodash
import { get } from 'lodash';

// STORE ACTION AND STATE
import { Actions as AuthActions, ActionTypes as AuthActionTypes } from '../../auth/store/actions';
import { Actions, ActionTypes } from './actions';
import { BusinessState, initialState } from './state';

/**
 * This effect is for listen business actions, execute auth service call and dispatch in business reducer.
 * For business api call purpose.
 *
 * @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 24/4/2020 (Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>)  created business effect
 */
export function reducer(state = initialState, action: Actions | AuthActions): BusinessState {
  switch (action.type) {
    // Business COMMON METHOD
    case ActionTypes.BUSINESS_COMMON: {
      return state;
    }
    // BUSINESS_COMMON_SUCCESS COMMON METHOD
    case ActionTypes.BUSINESS_COMMON_SUCCESS: {
      // commonly store and handle all business modules
      return {
        ...state,
        [action.response.common.STATE]: get(action.response.data, action.response.common.API_RESPONSE),
      };
    }

    // BUSINESS_SUCCESS COMMON METHOD
    case ActionTypes.BUSINESS_SUCCESS: {
      // store business setting
      return {
        ...state,
        business: action.response.data,
      };
    }
    // CLEAR_BUSINESS_REDUCER METHOD ON BUSINESS CHANGE
    case AuthActionTypes.CLEAR_BUSINESS_REDUCER: {
      return initialState;
    }
    // CLEAR_REDUCER METHOD ON LOGOUT
    case AuthActionTypes.CLEAR_REDUCER: {
      return initialState;
    }
    
    // DEFAULT
    default:
      return state;
  }
}
